<template>
  <div
    v-if="!redirectToGjirafaAccount"
    class="auth-wrapper auth-v2"
  >
    <div class="w-100">
      <b-row class="auth-inner m-0">
        <!-- Brand logo-->
        <b-link
          class="brand-logo login-logo login__logo"
        >
          <b-img
            v-show="landingInfo.imageUrl"
            :src="landingInfo.imageUrl"
            alt="logo"
          />
        </b-link>

        <b-col
          lg="8"
          class="d-none d-lg-flex align-items-center p-5"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
              fluid
              src="@/assets/images/pages/login-v2.svg"
              alt="Login V2"
            />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-5"
        >
          <b-col
            sm="8"
            md="6"
            lg="12"
            class="px-xl-2 mx-auto"
          >
            <div
              v-if="errorMessage"
              class="error__container"
            >
              <GjIcon
                name="InfoAlt_fill"
                class="text-danger mr-25"
              />
              {{ errorMessage }}!
            </div>
            <h2 class="mb-1 font-weight-bold card__title">
              {{ $tk('ClientPortal.Auth.WelcomeTo') }} Adnetwork!
            </h2>
            <!-- form -->
            <validation-observer
              ref="loginForm"
              #default="{invalid}"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="login"
              >
                <!-- email -->
                <b-form-group
                  :label="$tk('ClientPortal.User.Login.Email')"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="validateState(errors)"
                      name="login-email"
                      placeholder="john@example.com"
                      autofocus
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">{{ $tk('ClientPortal.User.Login.Password') }}</label>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="validateState(errors)!== null ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="validateState(errors)"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        :placeholder="$tk('ClientPortal.User.Login.PasswordPlaceholder')"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- submit buttons -->
                <b-button
                  size="sm"
                  type="submit"
                  variant="primary"
                  :disabled="invalid"
                  block
                >
                  {{ $tk('ClientPortal.User.SignIn') }}
                  <b-spinner
                    v-if="isLoggingIn"
                    class="ml-50"
                    label="Logging in..."
                    small
                    variant="light"
                  />
                </b-button>
              </b-form>
              <template>
                <div>
                  <div v-if="shouldDisplayLoginButton" :style="`display: flex; justify-content: center; gap: 3px; margin-top: 10px;`">
                    <label>Don't have an account?</label>
                    <label><a v-bind:href="'https://sso.gjirafa.com/Account/Regjistrohu?returnUrl=https://client.gjirafa.com'">Register</a></label>
                  </div>
                </div>
              </template>
            </validation-observer>
          </b-col>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'

import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import axios from '@/libs/axios'
import { mapActions, mapGetters } from 'vuex'
import { isUserLoggedIn } from '@/auth/utils'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { OIDC_STORE_MODULE } from '../../../../GjirafaFront/script/auth'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    GjIcon,
  },
  mixins: [togglePasswordVisibility],
  data() {
    const redirectToGjirafaAccount = !isUserLoggedIn() && (process.env.VUE_APP_CLIENT_LOGIN === 'integr8')
    console.log(redirectToGjirafaAccount, 'redirectToGjirafaAccount')
    return {
      status: '',
      password: '',
      userEmail: '',
      // validation rules
      required,
      email,
      appLogoImage: 'https://www.mall.tv/Content/malltv/img/malltv-logo.png',
      errorMessage: '',
      redirectToGjirafaAccount,
      isLoggingIn: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    ...mapGetters(['landingInfo']),
    shouldDisplayLoginButton() {
      const allowedKeywords = [
        'gjirafa.adplatform.gjirafa.tech',
        'admin.adplatform.gjirafa.dev',
      ]

      const currentUrl = window.location.href
      return allowedKeywords.some(keyword => currentUrl.includes(keyword))
    },
  },
  beforeMount() {
    if (!isUserLoggedIn() && process.env.VUE_APP_CLIENT_LOGIN === 'integr8') this.authenticateOidc(this.$route.query.redirectTo)
  },
  methods: {
    ...mapActions(OIDC_STORE_MODULE, [
      'authenticateOidc', // Authenticates with redirect to sign in if not signed in
    ]),
    login() {
      const data = {
        Email: this.userEmail,
        Password: this.password,
      }
      this.isLoggingIn = true
      axios.post('/user/login', data).then(response => {
        const { user, succedded, message } = response.data
        if (succedded) {
          const updatedUser = {
            displayName: user.displayName,
            email: user.email,
            id: user.id,
            picture: user.picture,
            ability: [{ action: 'manage', subject: 'all' }],
          }
          localStorage.setItem('accessToken', response.data.token)
          localStorage.setItem('userData', JSON.stringify(updatedUser))
          this.$ability.update(updatedUser.ability)
          this.$router.push('/')
        } else {
          this.errorMessage = message
          this.isLoggingIn = false
        }
      })
    },
    validateState(errors) {
      if (errors.length > 0 || this.errorMessage) { return false }
      return null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import '@/assets/scss/views/client/auth/login.scss';
</style>
